function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  if (summary.closest('.facets__disclosure-vertical') || summary.closest('.mobile-facets__details')){}else{
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
});

/***************Collection facets custom toggle ***************/
const desktop_Facets = document.querySelectorAll(".facets details");
const mobile_Facets = document.querySelectorAll("#FacetFiltersFormMobile details");

desktop_Facets.forEach(deet=>{
  deet.addEventListener('toggle', toggleOpenOneOnly)
})

function toggleOpenOneOnly(e) {
  if (this.open) {
    desktop_Facets.forEach(deet=>{
      if (deet!=this && deet.open) deet.open = false
    });
  }
}

mobile_Facets.forEach(deet=>{
  deet.addEventListener('toggle', mbl_toggleOpenOneOnly)
})

function mbl_toggleOpenOneOnly(e) {
  if (this.open) {
    mobile_Facets.forEach(deet=>{
      if (deet!=this && deet.open) deet.open = false
    });
  }
}
/***************Collection facets custom toggle ***************/

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if(elementToFocus != null){
    elementToFocus.focus();
    if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
      ? target.addEventListener(eventName, callback, false)
      : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector):not(.reset__button)').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
    document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.closest(".image-banner-slider")){
      var sliderSlides =this.querySelectorAll(".slideshow__slide");
      var firstSlide = this.querySelector('.slideshow__slide[slide-data-index="0"]');
      var lastSlide = this.querySelector('.slideshow').lastElementChild;
      if(event.currentTarget.name === 'next'){
        var activeSlide = this.querySelector(".slideshow__slide.active-slide");
        for (let i = 0; i < sliderSlides.length; i++) {
          if(sliderSlides[i].classList.contains("active-slide")){
            sliderSlides[i].classList.remove("active-slide");
            sliderSlides[i].setAttribute('aria-hidden', 'true');
            sliderSlides[i].removeAttribute('tabindex');
          } 
        }
        if(activeSlide.nextElementSibling != null && activeSlide.nextElementSibling.nextElementSibling != null ) {
          if(activeSlide.nextElementSibling.nextElementSibling.classList.contains("slideshow__slide")){
            activeSlide.nextElementSibling.nextElementSibling.classList.add("active-slide");
            activeSlide.nextElementSibling.nextElementSibling.setAttribute('aria-hidden', 'false');
            activeSlide.nextElementSibling.nextElementSibling.setAttribute('tabindex', '-1');
            var slideIndex = activeSlide.nextElementSibling.nextElementSibling.getAttribute('slide-data-index');
            var Allbuttons = this.querySelectorAll(".slider-counter__link");
              for (let i = 0; i < Allbuttons.length; i++) {
                Allbuttons[i].classList.remove("slider-counter__link--active");
                var buttonIndex = Allbuttons[i].getAttribute('button-data-index');
                if(slideIndex == buttonIndex){
                  Allbuttons[i].classList.add("slider-counter__link--active");
                }
              }
            
          }
        }
        else{
          firstSlide.classList.add("active-slide");
          firstSlide.setAttribute('aria-hidden', 'false');
          firstSlide.setAttribute('tabindex', '-1');
          var firstSlideIndex = firstSlide.getAttribute('slide-data-index');
          var Allbuttons = this.querySelectorAll(".slider-counter__link");
          for (let i = 0; i < Allbuttons.length; i++) {
            Allbuttons[i].classList.remove("slider-counter__link--active");
            var buttonIndex = Allbuttons[i].getAttribute('button-data-index');
            if(firstSlideIndex == buttonIndex){
              Allbuttons[i].classList.add("slider-counter__link--active");
            }
          }
        }   
      }

      if(event.currentTarget.name === 'previous'){
        console.log(lastSlide);
        var activeSlide2 = this.querySelector(".slideshow__slide.active-slide");
        for (let i = 0; i < sliderSlides.length; i++) {
          if(sliderSlides[i].classList.contains("active-slide")){
            sliderSlides[i].classList.remove("active-slide");
            sliderSlides[i].setAttribute('aria-hidden', 'true');
            sliderSlides[i].removeAttribute('tabindex');
          } 
        }
        if(activeSlide2.previousElementSibling != null && activeSlide2.previousElementSibling.previousElementSibling != null ) {
          if(activeSlide2.previousElementSibling.previousElementSibling.classList.contains("slideshow__slide")){
            activeSlide2.previousElementSibling.previousElementSibling.classList.add("active-slide");
            activeSlide2.previousElementSibling.previousElementSibling.setAttribute('aria-hidden', 'false');
            activeSlide2.previousElementSibling.previousElementSibling.setAttribute('tabindex', '-1');
            var slideIndex = activeSlide2.previousElementSibling.previousElementSibling.getAttribute('slide-data-index');
            var Allbuttons = this.querySelectorAll(".slider-counter__link");
              for (let i = 0; i < Allbuttons.length; i++) {
                Allbuttons[i].classList.remove("slider-counter__link--active");
                var buttonIndex = Allbuttons[i].getAttribute('button-data-index');
                if(slideIndex == buttonIndex){
                  Allbuttons[i].classList.add("slider-counter__link--active");
                }
              }
          }
        }
        else{
          lastSlide.classList.add("active-slide");
          lastSlide.setAttribute('aria-hidden', 'false');
          lastSlide.setAttribute('tabindex', '-1');
          var lastSlideIndex = lastSlide.getAttribute('slide-data-index');
          var Allbuttons = this.querySelectorAll(".slider-counter__link");
          for (let i = 0; i < Allbuttons.length; i++) {
            Allbuttons[i].classList.remove("slider-counter__link--active");
            var buttonIndex = Allbuttons[i].getAttribute('button-data-index');
            if(lastSlideIndex == buttonIndex){
              Allbuttons[i].classList.add("slider-counter__link--active");
            }
          }
        } 
      }
    }
    else{
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
          event.currentTarget.name === 'next'
              ? this.slider.scrollLeft + step * this.sliderItemOffset
              : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
      });
    }

  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    // console.log(this.sliderControlWrapper)
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
            'click',
            () => {
              this.announcementBarArrowButtonWasClicked = true;
            },
            { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
          ? this.pause()
          : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
          this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
          event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
        !this.reducedMotion.matches &&
        !this.announcementBarArrowButtonWasClicked &&
        this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
          event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
        this.currentPage === this.sliderItems.length
            ? 0
            : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');

      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    
    if (event.currentTarget.closest(".image-banner-slider")){
      var currentTarget = this.sliderControlLinksArray.indexOf(event.currentTarget);    
      var sliderElement = this.querySelectorAll(".slideshow__slide");
      var allbuttons = this.querySelectorAll(".slideshow__control-wrapper .slider-counter__link");
      for (let i = 0; i < allbuttons.length; i++) {
        allbuttons[i].classList.remove("slider-counter__link--active");
      }
      event.currentTarget.classList.add("slider-counter__link--active");
      this.classList.add("slider-counter__link--active");
      for (let i = 0; i < sliderElement.length; i++) {
        var SlideDataIndex = sliderElement[i].getAttribute("slide-data-index");
        sliderElement[i].classList.remove("active-slide");
        sliderElement[i].setAttribute('aria-hidden', 'true');
        sliderElement[i].removeAttribute('tabindex');
        if( SlideDataIndex ==  currentTarget ){
          sliderElement[i].classList.add("active-slide");
          sliderElement[i].setAttribute('aria-hidden', 'false');
          sliderElement[i].setAttribute('tabindex', '-1');
        }
      }
    }
    else{
      const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition,
      });
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();

    if(this.closest('.card__content') != null){
      this.updateRadios();
    }else{
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      if(this.closest('#product-bar--sticky') != null){
        this.updateStickyRadios();
      }
      if(this.closest('body.main-product') != null){
        this.updateSwatchOptions();
      }
    }
  }

  updateRadios() {
    //update variant ID
    var productForms = this.closest('.card__content').querySelectorAll(
        `#product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    //Update Radio/select on change
    if(this.classList.contains('variant-selects')){
      var inputSelects = this.querySelectorAll('select');
      for(let i=0;i<inputSelects.length;i++){
        var inputSelectValue = inputSelects[i].value;
        this.closest('form').querySelector('variant-radios input[value="'+inputSelectValue+'"]').checked = true;
      }
    }else if(this.classList.contains('variant-radios')){
      var inputRadios = this.querySelectorAll('input[type="radio"]:checked');
      for(let i=0;i<inputRadios.length;i++){
        var inputRadioValue = inputRadios[i].value;
        this.closest('form').querySelector('variant-selects select option[value="'+inputRadioValue+'"]').selected = true;
      }
    }

    //Update ATC
    this.closest('form').querySelector('[name="add"]').setAttribute('aria-disabled', false);
    this.closest('form').querySelector('[name="add"] .atc-message').classList.remove('hidden');
    this.closest('form').querySelector('[name="add"] .sold-out-message').classList.add('hidden');
  }

  updateStickyRadios() {
    // Update variant-selects - Sticky bar
    if(this.classList.contains('variant-selects')){
      var inputSelects = this.querySelectorAll('select');
      for(let i=0;i<inputSelects.length;i++){
        var inputSelectValue = inputSelects[i].value;
        var variantSelectors = document.querySelectorAll('product-info variant-radios input[value="'+ inputSelectValue +'"]');
        for(var j = 0; j < variantSelectors.length; j++){
          variantSelectors[j].checked = true;
          if(variantSelectors[j].checked == true){
            $('product-info variant-radios input[value="'+ inputSelectValue +'"]').trigger("click");
          }
        }
      }
    }
  }

  updateSwatchOptions(){
    // Update variant-radios - Swatches 
    if(this.classList.contains('product-swatches')){
      var inputSelectsRadios = this.querySelectorAll('.product-swatches input[type="radio"]:checked');
      for(let i=0;i<inputSelectsRadios.length;i++){
        var inputRadioValue = inputSelectsRadios[i].value;
        var stickySelected = document.querySelectorAll('variant-selects select option[value="'+inputRadioValue+'"]');
        for(var j = 0; j < stickySelected.length; j++){
          stickySelected[j].selected = true;
          if(stickySelected[j].selected == true){
            $('variant-selects select option[value="'+inputRadioValue+'"]').trigger("change");
          }
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
    )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const sticky_destination = document.getElementById(`sticky-price-${this.dataset.section}`);
          const sticky_destination_mob = document.getElementById(`mobile-sticky-price-${this.dataset.section}`);
          const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const sticky_source = html.getElementById(
              `sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const sticky_source_mob = html.getElementById(
              `mobile-sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (sticky_source && sticky_destination) sticky_destination.innerHTML = sticky_source.innerHTML;
          if (sticky_source_mob && sticky_destination_mob) sticky_destination_mob.innerHTML = sticky_source_mob.innerHTML;

          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);
          const sticky_price = document.getElementById(`sticky-price-${this.dataset.section}`);
          const sticky_price_mob = document.getElementById(`sticky-price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');
          if (sticky_price) sticky_price.classList.remove('visibility-hidden');
          if (sticky_price_mob) sticky_price_mob.classList.remove('visibility-hidden');

          if (inventoryDestination)
            inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(
              addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
              window.variantStrings.soldOut
          );

          const stickyAddButtonUpdated = html.getElementById(`ProductStickySubmitButton-${sectionId}`);
          this.stickyToggleAddButton(
              stickyAddButtonUpdated ? stickyAddButtonUpdated.hasAttribute('disabled') : true,
              window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  stickyToggleAddButton(disable = true, text, modifyClass = true) {
    const stickyProductForm = document.getElementById(`sticky-product-form-${this.dataset.section}`);
    if (!stickyProductForm) return;
    const stickyAddButton = stickyProductForm.querySelector('[name="add"]');
    const stickyAddButtonText = stickyProductForm.querySelector('[name="add"] > span');
    if (!stickyAddButton) return;

    if (disable) {
      stickyAddButton.setAttribute('disabled', 'disabled');
      if (text) stickyAddButtonText.textContent = text;
    } else {
      stickyAddButton.removeAttribute('disabled');
      stickyAddButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const sticky_price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (sticky_price) sticky_price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch((e) => {
            console.error(e);
          });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* mega-menu */

var chldMenuParent =  document.querySelectorAll(".mega-menu.secondary-menu .child-link-parent.has-grand-childs > .link");
if(chldMenuParent != null){
  for (let i = 0; i < chldMenuParent.length; i++) {
    chldMenuParent[i].addEventListener("click", function(e){
      e.preventDefault();
      var AllParents = this.closest(".secondary-menu").querySelectorAll(".child-link-parent.has-grand-childs");
      for (let j = 0; j <  AllParents.length; j++) {
        AllParents[j].classList.remove("show-child-links");
      }
      this.parentElement.classList.add("show-child-links");
    });
  }
}

/* mega-menu */

// Product sticky ATC bar
function stickyProductBar() {
  var window_top = $(window).scrollTop();
  if (typeof($('.product .product-form__submit').offset()) != "undefined"){
    var buttonDiv = $('.product .product-form__submit').offset().top + 50;
    if (window_top > buttonDiv) {
      $('#product-bar--sticky').addClass('show');
    } else {
      $('#product-bar--sticky').removeClass('show');
    }
  }
}
// Update Swatch Colors text
function productSwatches(){
  var swatch_color = $('.product .swatch-color').val();
  if(swatch_color != null){
    $('.product .selected-color').html(swatch_color);
    $('.product .swatch-color').click(function(){
      var current_color = this.getAttribute('value');
      $('.product .selected-color').html(current_color);
    });
  }
}
// Product Tabs
function productTabs(){
  var mainTabsToggle = document.querySelectorAll('.tab-menu .tab a');
  var mainTabsContent = document.querySelectorAll('.product-tabs .tab-content');
  mainTabsToggle.forEach((tabToggle) => {
    tabToggle.addEventListener('click', function(e){
      e.preventDefault();
      mainTabsToggle.forEach((allTabToggle,index) => {
        allTabToggle.parentElement.classList.remove('is-active');
        mainTabsContent[index].classList.remove('is-active');
      });
      var tabsContentHref = this.getAttribute('href');
      var tabsContent = document.querySelector(tabsContentHref);
      tabsContent.classList.add('is-active');
      this.parentElement.classList.add('is-active');
    });
  });
}

$( document ).ready(function() {
  $(window).on('scroll',function(e){
    stickyProductBar()
  });
  stickyProductBar();
  productSwatches();
  productTabs();
});

/*******************Wait Element Functions****************/
function waitForElement(selector, callback) {
  if (document.querySelector(selector) !== null) {
    callback();
  } else {
    setTimeout(function() {
      waitForElement(selector, callback);
    }, 100);
  }
};
/*******************Wait Element Functions****************/

/* Quickview modal JS start */

// Quick view Back to Shop button
waitForElement('quick-add-modal.quick-add-modal[open]',function() {
  document.addEventListener('click', function(e){
    var shop_close_btn = e.target.classList.contains('quick-add-modal__toggle_text')
    if(shop_close_btn){
      var close_btn = e.target.closest('.quick-add-modal').querySelector('.quick-add-modal__toggle');
      close_btn.click();
    }
  });
});
// Quickview Product Swatches
var quickview_btn = document.querySelectorAll('.quick-add__submit');
for(var i=0; i < quickview_btn.length; i++){
  quickview_btn[i].addEventListener('click', function(e){
    waitForElement('quick-add-modal.quick-add-modal[open]',function(){
      productSwatches();
    });
  });
}
/* Quickview modal JS end */
/* Custom search filter start */
document.addEventListener('click', function(e){
  if(e.target.closest('.template-search__search .search-list')){
    var search_trigger = e.target.closest('.template-search__search').querySelector('.field.hidden .search__button')
    search_trigger.click();
  }
});
/* Custom search filter end */
/* FAQ Scroll to Element start */
$(document).ready(function () {
  if(document.querySelectorAll('.faq-row').length > 0){
    var headerSpace = 0;
    var faqlinklistheight = 0;
    $(window).on("load resize scroll",function(e){
      if(document.querySelectorAll('sticky-header.header-wrapper').length == 1){
        headerSpace = document.querySelector('sticky-header.header-wrapper').offsetHeight;
      }
      if($('.shopify-section.section-header.shopify-section-header-sticky').hasClass('shopify-section-header-hidden')){
        // document.querySelector('.faq-row .link-list').offsetHeight
        faqlinklistheight = 0;
      } else {
        faqlinklistheight = document.querySelector('.faq-row .link-list').offsetHeight;
      }
    });
    // Assign active class to nav links while scolling
    var lastScrollTop = 0;
    $(window).scroll(function () {
      var scrollDistance = $(window).scrollTop();
      var botttomToTop = 0;
      st = $(this).scrollTop();
      if(st < lastScrollTop) {
        if($(window).width() < 990){
          botttomToTop = document.querySelector('.faq-row .link-list').offsetHeight + document.querySelector('sticky-header.header-wrapper').offsetHeight + 20;
        } else {
          botttomToTop = document.querySelector('sticky-header.header-wrapper').offsetHeight + 20;
        }
      } else {
        if($(window).width() < 990){
          botttomToTop = document.querySelector('.faq-row .link-list').offsetHeight + 20;
        } else {
          botttomToTop = 0;
        }
      }
      scrollDistanceN = $('.faq-row .faq-cotnent-box').offset().top - botttomToTop;
      lastScrollTop = st;
      if(scrollDistanceN > scrollDistance){
        $('.faq-row .link-list li .btn-link.active').removeClass('active');
        $('.faq-row .link-list li .btn-link').eq(0).addClass('active');
      } else {
        var firstLink = $('.faq-row .faq-cotnent-box .page-section').eq(1).offset().top + botttomToTop;
        // if($('.faq-row .faq-cotnent-box').offset().top > $(window).scrollTop()){
        if(firstLink > $(window).scrollTop()){
        } else {
          $('.page-section').each(function (i) {
            if ($(this).position().top - botttomToTop <= scrollDistance) {
              var thisEl = document.querySelectorAll('.faq-row .link-list li .btn-link')[i];
              $('.faq-row .link-list li .btn-link.active').removeClass('active');
              $('.faq-row .link-list li .btn-link').eq(i).addClass('active');
            }
          });
        }
      }
    }).scroll();

    $('.faq-row .link-list li .btn-link').bind('click', function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var thisEl = this;
      var target = $(this).attr("data-target"); // Set the target as variable
      if(target == 'cotnent-all'){
        // $('.faq-row .link-list li .btn-link.active').removeClass('active');
        // $('.faq-row .link-list li .btn-link').eq(0).addClass('active');
        $('html, body').stop().animate({
          scrollTop: $('.shopify-section.section.main-faq').offset().top
        }, 100);
      } else {
        if(target == 'cotnent-faq-orders') {
          setTimeout(function() {
            $('.faq-row .link-list li .btn-link.active').removeClass('active');
            $('.faq-row .link-list li .btn-link').eq(1).addClass('active');
          }, 450);
        }
        if($('#'+target).offset().top > $(window).scrollTop()){
          if($(window).width() < 990){
            var botttomToTop = document.querySelector('sticky-header.header-wrapper').offsetHeight + 20;
          } else {
            var botttomToTop = 20;
          }
          $('html, body').stop().animate({
            scrollTop: $('#'+target).offset().top - botttomToTop
          }, 100, function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
          });
        } else {
          if($(window).width() < 990){
            var botttomToTop = document.querySelector('sticky-header.header-wrapper').offsetHeight + document.querySelector('.faq-row .link-list').offsetHeight;
          } else {
            var botttomToTop = document.querySelector('sticky-header.header-wrapper').offsetHeight + 15;
          }

          $('html, body').stop().animate({
            scrollTop: $('#'+target).offset().top - botttomToTop
          }, 100, function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
          });
        }
      };
      return false;
    });
  }
});
/* FAQ Scroll to Element End */
/* Accordion start */
const accordionItemHeaders = document.querySelectorAll(
    ".accordion-item-header"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    // Uncomment in case you only want to allow for the display of only one collapsed item at a time!

    const currentlyActiveAccordionItemHeader = document.querySelector(
        ".accordion-item-header.active"
    );
    if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
    ) {
      currentlyActiveAccordionItemHeader.classList.toggle("active");
      currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
    }
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      console.log(accordionItemBody)
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });

});
window.addEventListener("resize", function(event) {
  if(document.querySelectorAll(".accordion-item-header.active").length > 0 ){
    if(document.querySelector(".accordion-item-header.active + .accordion-item-body").style.maxHeight !== '0px'){
      document.querySelector(".accordion-item-header.active + .accordion-item-body").style.maxHeight = 'none';
    }
  }
});
/* Accordion End */

/* About Read more start */
$(document).ready(function() {
  $(".shopify-section.about-image-with-text .readmoreWrap .morelink").click(function(){
    $(this).closest('.readmoreWrap').find('.morecontentToggle').toggleClass('active');
    return false;
  });
});
/* About Read more End */

/* Custom newsletter pop start */
if(document.querySelectorAll('.newsletter-popup').length > 0){
  var newsletterPopup= $(".newsletter-popup");
  var newsletterPopupClose= $(".pop-in__close-button");
  var apparitionDelay = parseInt(newsletterPopup.attr("apparition-delay") || 0) * 1e3;
  var attr = $(".newsletter-popup").attr('only-once');
  if (typeof attr !== 'undefined' && localStorage.getItem("theme:popup-appeared") !== "true" || localStorage.getItem("theme:popup-appeared") !== "true" || typeof attr == 'undefined' && localStorage.getItem("theme:popup-appeared") === "true" ) {
    setTimeout(() => newsletterPopup.show(), apparitionDelay);
    setTimeout(() => $("body").addClass('pop-up-visible'), apparitionDelay);
    localStorage.setItem("theme:popup-appeared", "true");
  }
  newsletterPopupClose.click(function(){
    newsletterPopup.css("display", "none");
    $("body").removeClass('pop-up-visible');
  });
}
/* Custom newsletter pop end */



if(document.querySelectorAll('.footer-block__newsletter #ContactFooter').length > 0){
  $(".footer-block__newsletter #ContactFooter").submit(function(){
    $(this).addClass('loading')
  });
}

/***** Set Banner + Drawer height *****/
function setBannerHeight() {
  var windowHeight = $(window).height();
      headerHeight = $('header.header').height();
      announcementHeight = $('.utility-bar').height();      
      drawerHeight = $('#menu-drawer');
      if($('.utility-bar') != null){
        
        
        // Set drawer height
        if($('.shopify-section-header-sticky').length == 0){
          drawer_vh = windowHeight - announcementHeight;
        }else{
          drawer_vh = windowHeight;
        }
        drawerHeight.height(drawer_vh);
      }else{
        
      }
    
}
$(window).on("load resize scroll", function() {
  setBannerHeight();
});
/***** Set Banner + Drawer height *****/
/***** Trigger Mega Menu on Hover start */
$(window).on("load", function() {
  $("header-menu .mega-menu").hover(function(){
      $(this).prop('open', true);
      $('body').css('overflow-y', 'auto');    
  }, function(){
      $(this).prop('open', false);
  });
});
/***** Trigger Mega Menu on Hover end */
function newsletter(news_id){
var check_url = window.location.href.indexOf(news_id);
var target = $('#'+news_id)
if(check_url > 0){
  $( 'html, body' ).animate({
		scrollTop: $( target ).offset().top
  }, '300' );
}
}
newsletter("ContactFooterDesktop");
newsletter("ContactFooterMobile");

/***** Hide Empty Paragraph from Articles */
const paragraphs = document.querySelectorAll('.article-template p');

paragraphs.forEach(paragraph => {
  if (paragraph.textContent.includes('\u00A0')) {
    paragraph.style.display = 'none';
  }
});
/***** Scroll to Faq queations ****/
function faq_scroll(faq_id){
  var check_id = window.location.href.indexOf(faq_id);
  var faq_target = $('#'+faq_id);
  if(check_id > 0){
    $( 'html, body' ).animate({
      scrollTop: $( faq_target ).offset().top - 150
    }, '300' );
    faq_target.find('.accordion-item-header')[0].click();
  }
}
$(window).on("load", function() {
  faq_scroll("cotnent-faq-shipping");
  faq_scroll("cotnent-faq-returns-exchanges");
});
/***** Scroll to Faq queations ****/

/***** Apply In stock filter on load *****
$(window).on("load", function() {
  var inStockFilter = $('.collection .facets-wrap-vertical input[name="filter.v.availability"][value="1"]:not(:checked)');
  if(inStockFilter != null){
    inStockFilter.trigger('click');
  }
});
***** Apply In stock filter on load *****/
